import React from 'react';
import style from './LegendElement.module.css';

function LegendElement({value, unit, icon, title, isReverseIcon, ...props}) {

    function addClassName(className, classNameToAdd) {
        return className + ' ' + classNameToAdd
    }

    return (
        <div className={style.main} {...props}>
            <div className={isReverseIcon ? addClassName(style.valueAndUnit, style.justifyContentRight) : style.valueAndUnit}>
                <div>
                    {value}
                </div>

                <div className={style.unit}>
                    {unit}
                </div>
            </div>

            <div className={isReverseIcon ? addClassName(style.iconAndTitle, style.reverseIcon) : style.iconAndTitle}>
                <div>
                    {icon}
                </div>

                <div className={style.title}>
                    {title}
                </div>
            </div>

        </div>
    );
}

export default LegendElement;